import { formatVolume } from './seoMetrics';
import type { TreeNode, TreeStats } from '../types';

export function computeTreeStats(nodesById: Map<string, TreeNode>): TreeStats {
  let clusters = 0;
  let keywords = 0;
  let maxDepth = 0;
  let totalVolume = 0;
  let difficultySum = 0;
  let difficultyCount = 0;

  nodesById.forEach(node => {
    maxDepth = Math.max(maxDepth, node.depth);
    if (node.isLeaf) {
      keywords += 1;
      totalVolume += Number(node.seo?.search_volume_miztols) || 0;
      if (node.seo?.difficulty != null) {
        difficultySum += Number(node.seo.difficulty);
        difficultyCount += 1;
      }
    } else {
      clusters += 1;
    }
  });

  return {
    total: nodesById.size,
    clusters,
    keywords,
    maxDepth,
    totalVolume,
    totalVolumeLabel: formatVolume(totalVolume),
    avgDifficulty: difficultyCount
      ? Math.round(difficultySum / difficultyCount)
      : null
  };
}

export function collectKeywordSet(nodesById: Map<string, TreeNode>): Set<string> {
  return new Set(
    [...nodesById.values()].filter(n => n.isLeaf).map(n => n.label)
  );
}

export function compareKeywordSets(a: Set<string>, b: Set<string>) {
  const onlyA = [...a]
    .filter(x => !b.has(x))
    .sort((x, y) => x.localeCompare(y, 'fa'));
  const onlyB = [...b]
    .filter(x => !a.has(x))
    .sort((x, y) => x.localeCompare(y, 'fa'));
  const shared = [...a]
    .filter(x => b.has(x))
    .sort((x, y) => x.localeCompare(y, 'fa'));
  return { onlyA, onlyB, shared };
}
